import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Label } from "../../../../../components/ui/label";
import { Switch } from "../../../../../components/ui/switch";
import Field from "../../../../../components/shared/Form/Field";
import Select from "../../../../../components/shared/inputs/Select";
import { useGroups } from "../../../General/OrganisationLevelGroups/context";
import OptionsTable from "../../components/OptionsTable";
import { renderSettingsResourceLabel } from "../../../../../utils/helpers/settings";

const pageSizes: number[] = [10, 20, 30, 40, 50, 100];

function Settings() {
    const { t } = useTranslation();

    const { allocatedGroups } = useGroups();

    const options = useMemo(() => [
        { label: t("employee-number"), name: "hideEmployeeNumber" },
        {
            label: renderSettingsResourceLabel(allocatedGroups[0]),
            name: "hideGroup",
            disabled: allocatedGroups?.length !== 1,
        },
        { label: t("project"), name: "hideProject" },
        { label: t("summary-tooltip"), name: "hideSummaryTooltip" },
        { label: t("miss-punch-tooltip"), name: "hideMissPunchTooltip" },
        { label: t("daily-summary"), name: "timeSheet.hideDailySummary" },
        { label: t("clock-date-picker"), name: "timeSheet.hideClockDatePicker" },
    ], [t, allocatedGroups]);

    return (
        <div className="tw-flex tw-flex-col tw-gap-6">
            <Field name="defaultPageSize" label={t("default-page-size")} className="tw-max-w-xs tw-mb-0" shouldUnregister={false}>
                <Select>
                    {pageSizes.map((page) => (
                        <Select.Item key={page} value={String(page)}>{page}</Select.Item>
                    ))}
                </Select>
            </Field>

            <div className="tw-flex tw-items-center tw-gap-2">
                <Field name="mandatoryNoteOnEdit" valuePropName="checked" className="tw-mb-0" shouldUnregister={false}>
                    <Switch id="mandatoryNoteOnEdit" />
                </Field>
                <Label htmlFor="mandatoryNoteOnEdit" className="tw-mb-1">
                    {t("mandatory-note-on-edit")}
                </Label>
            </div>

            <div className="tw-flex tw-items-center tw-gap-2">
                <Field name="mandatoryNoteOnCreate" valuePropName="checked" className="tw-mb-0" shouldUnregister={false}>
                    <Switch id="mandatoryNoteOnCreate" />
                </Field>
                <Label htmlFor="mandatoryNoteOnCreate" className="tw-mb-1">
                    {t("mandatory-note-on-create")}
                </Label>
            </div>

            <OptionsTable fields={options} />
        </div>
    );
}

export default Settings;
